export default __webpack_public_path__ + "static/media/mdi_user.3f0d018a.svg";